'use memo'

import {
  TaskCategoryTaskType,
  useGetAutopilotTasksForCampaign,
  useInvalidateUseGetAutopilotTasksForCampaign,
} from '@urbanx/agx.activities.client'
import {
  CampaignActionRequest,
  CampaignActionRequestCampaignAction,
  CampaignDetailModelStage,
  usePerformCampaignAction,
} from '@urbanx/agx.campaigns.client'
import {
  AgxButton,
  AgxModal,
  AgxSpacer,
  AgxYesNoQuestion,
  Icon_AlertCircleOutline,
  Icon_FeaturedIcon,
  YesNo,
} from '@urbanx/agx.ui-components2'
import { useSelectedCampaign } from 'hooks'
import { useState } from 'react'

const WithdrawListingAction = () => {
  const { campaign } = useSelectedCampaign()
  const [hasFundInTrust, setHasFundInTrust] = useState<boolean | undefined>()
  const [showConfirmation, setShowConfirmation] = useState(false)
  const invalidateTasks = useInvalidateUseGetAutopilotTasksForCampaign()
  const { data: tasks } = useGetAutopilotTasksForCampaign(
    campaign?.campaignId ?? '',
    undefined,
    !!campaign?.campaignId
  )

  const { performCampaignAction } = usePerformCampaignAction({
    onSuccess: async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000))
      await invalidateTasks(campaign?.campaignId ?? '')
    },
    onError: () => {},
  })

  const withdrawnTask = tasks?.find(
    (task) => task.category?.taskType === TaskCategoryTaskType.Withdrawn
  )

  const confirmWithdrawal = () => {
    if (hasFundInTrust === undefined) return

    const request: CampaignActionRequest = {
      campaignId: campaign?.campaignId,
      campaignAction: CampaignActionRequestCampaignAction.Withdraw,
      hasFundInTrust,
    }

    performCampaignAction(request)
    setShowConfirmation(false)
  }

  return (
    <>
      <AgxButton
        id="btnWithdrawListing"
        text="Withdraw Listing"
        variant="naked"
        danger
        onClick={() => setShowConfirmation(true)}
        disabled={
          campaign?.stage === CampaignDetailModelStage.ListingWithdrawn ||
          (withdrawnTask && !withdrawnTask.isLocked)
        }
      />
      <AgxModal
        title="Mark as Withdrawn?"
        titleIcon={
          <Icon_FeaturedIcon
            icon={<Icon_AlertCircleOutline type="Danger" />}
            color="var(--text-error)"
            backgroundColor="var(--bg-error-light)"
          />
        }
        type="single"
        variant="withDivider"
        actionButtonContainerStyle="withoutDivider"
        actionButtons={
          <>
            <AgxButton
              id="btnCancel"
              text="Cancel"
              variant="hollow"
              size="large"
              onClick={() => setShowConfirmation(false)}
              stretch
            />
            <AgxButton
              id="btnConfirm"
              text="Confirm"
              variant="primary"
              danger
              size="large"
              onClick={confirmWithdrawal}
              stretch
              disabled={hasFundInTrust === undefined}
            />
          </>
        }
        content={
          <AgxSpacer
            direction="vertical"
            fill
            padding={{ top: 'md', bottom: 'xl', left: 'xl', right: 'xl' }}
          >
            <AgxYesNoQuestion
              id="fundsInTrustQuestion"
              onValueChanged={({ value }: { id: string; value: string }) =>
                setHasFundInTrust(value === YesNo.Yes)
              }
              defaultValue={
                hasFundInTrust === undefined
                  ? undefined
                  : hasFundInTrust
                    ? YesNo.Yes
                    : YesNo.No
              }
              label="Are there any funds in trust?"
              yesLabel="Yes"
              noLabel="No"
              reverseLabelOrder
              required
            />
          </AgxSpacer>
        }
        isOpen={showConfirmation}
        setIsDialogOpen={setShowConfirmation}
      />
    </>
  )
}

export default WithdrawListingAction
